var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const getRichMapScriptCandidates = (domainToUse, richmapFilename) => {
    if (domainToUse.startsWith('qa-dnaspaces.io')) {
        return ['https://rmsmaps.qa-dnaspaces.io/js/' + richmapFilename];
    }
    if (domainToUse.startsWith('ciscospaces.io') ||
        domainToUse.startsWith('dnaspaces.io')) {
        return ['//maps.ciscospaces.io/js/' + richmapFilename];
    }
    if (domainToUse.startsWith('ciscospaces.eu') ||
        domainToUse.startsWith('dnaspaces.eu')) {
        return [
            '//maps.ciscospaces.eu/js/' + richmapFilename,
            '//rms.dnaspaces.eu/js/' + richmapFilename,
        ];
    }
    if (domainToUse.startsWith('ciscospaces.sg') ||
        domainToUse.startsWith('dnaspaces.sg')) {
        return [
            '//maps.ciscospaces.sg/js/' + richmapFilename,
            '//rms.ciscospaces.sg/js/' + richmapFilename,
        ];
    }
    return ['//rms.' + domainToUse + '/js/' + richmapFilename];
};
export const probeRichMapScriptAvailability = (scriptUrl) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch(scriptUrl, { method: 'HEAD' });
        if (response.status === 405 || response.status === 501) {
            return null;
        }
        return response.ok;
    }
    catch (error) {
        console.log('Unable to verify rich maps script availability before loading.', scriptUrl, error);
        return null;
    }
});
export const resolveRichMapScriptUrl = (richMapUrls, probeScript = probeRichMapScriptAvailability) => __awaiter(void 0, void 0, void 0, function* () {
    const [primaryUrl, fallbackUrl] = richMapUrls;
    if (!fallbackUrl) {
        return primaryUrl;
    }
    const primaryUrlAvailable = yield probeScript(primaryUrl);
    if (primaryUrlAvailable === false) {
        return fallbackUrl;
    }
    return primaryUrl;
});
